import { render, staticRenderFns } from "./afterForm.vue?vue&type=template&id=f92a0cd2&"
import script from "./afterForm.vue?vue&type=script&lang=js&"
export * from "./afterForm.vue?vue&type=script&lang=js&"
import style0 from "./afterForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports